export default [{
    path: "/password/reset/:token",
    name: null,
}]
